/**
 * This will convert our menu into a hierarchical list rather than the standard flat list it returns
 * as WPGraphQL returns flat-list menus by default.
 * @example const myMenu = flatListToHierarchical(menuItems?.nodes)
 * @return Returns a hierarchical list.
 */

export const flatListToHierarchical = (
  data = [],
  { idKey = "id", parentKey = "parentId", childrenKey = "childItems" } = {},
) => {
  const tree = [];
  const childrenOf = {};
  data.forEach((item) => {
    const newItem = { ...item };
    const { [idKey]: id, [parentKey]: parentId = 0 } = newItem;
    childrenOf[id] = childrenOf[id] || [];
    newItem[childrenKey] = childrenOf[id];
    parentId ? (childrenOf[parentId] = childrenOf[parentId] || []).push(newItem) : tree.push(newItem);
  });
  return tree;
};
